import { createStyles } from 'antd-style';
import  colorToken  from '../../utils/colorToken';

export const useDocumentModalStyles = createStyles(({ token }) => ({
  modal: {
    '.ant-modal-content': {
      padding: 0,
      height: '90vh',
    },
    display: 'flex',
    flexDirection: 'column',
    
    '.ant-modal-footer': {
      padding: `0 ${token.paddingLG}px`,
    },
  },
  
  modalHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: `2px ${token.paddingLG}px`,
    background: 'var(--color-bg-container, #ffffff)',
  },
  
  titleEditContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: token.marginMD,
    flex: 1,
  },
  
  titleIcon: {
    fontSize: '20px',
    color: 'var(--color-primary, #1890ff)',
    flexShrink: 0,
  },
  
  titleInputWrapper: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    borderRadius: token.borderRadius,
    transition: 'all 0.2s ease-in-out',
    maxWidth: '40%',
    '&:hover': {
      backgroundColor: 'var(--color-bg-container, #ffffff)',
    },
  },
  
  titleInput: {
    flex: 1,
    fontSize: `${token.fontSizeHeading4}px`,
    fontWeight: token.fontWeightStrong,
    color: 'var(--color-text-base, #000000)',
    border: '2px solid transparent',
    borderRadius: token.borderRadius,
    outline: 'none',
    padding: `${token.paddingSM}px ${token.paddingMD}px`,
    backgroundColor: 'transparent',
    transition: 'all 0.2s ease-in-out',
    
    '&:hover': {
      borderColor: 'var(--color-border, #d9d9d9)',
      backgroundColor: 'var(--color-bg-container, #ffffff)',
    },
    
    '&:focus': {
      borderColor: 'var(--color-primary, #1890ff)',
      backgroundColor: 'var(--color-bg-container, #ffffff)',
      boxShadow: '0 0 0 2px rgba(24, 144, 255, 0.2)',
    },
    
    '&::placeholder': {
      color: 'var(--color-text-placeholder, #bfbfbf)',
      fontWeight: 'normal',
    },
  },
  
  titleDisplay: {
    display: 'flex',
    alignItems: 'center',
    gap: token.marginSM,
    flex: 1,
    
    'h2': {
      margin: 0,
      fontSize: `${token.fontSizeHeading4}px`,
      fontWeight: token.fontWeightStrong,
      color: 'var(--color-text-base, #000000)',
    },
  },
  
  readOnlyBadge: {
    fontSize: `${token.fontSizeSM}px`,
    padding: `${token.paddingXS}px ${token.paddingSM}px`,
    borderRadius: token.borderRadiusSM,
    backgroundColor: 'var(--color-info-bg, #e6f7ff)',
    color: 'var(--color-info, #1890ff)',
    border: `1px solid var(--color-info-border, #91d5ff)`,
    fontWeight: token.fontWeightMedium,
  },
  
  saveStatus: {
    fontSize: `${token.fontSizeSM}px`,
    padding: `${token.paddingXS}px ${token.paddingSM}px`,
    borderRadius: token.borderRadiusSM,
    fontWeight: token.fontWeightMedium,
    minWidth: '80px',
    textAlign: 'center',
  },
  
  saveStatusSaved: {
    backgroundColor: 'var(--color-success-bg, #f6ffed)',
    color: 'var(--color-success, #52c41a)',
    border: `1px solid var(--color-success-border, #b7eb8f)`,
  },
  
  saveStatusSaving: {
    backgroundColor: 'var(--color-warning-bg, #fffbe6)',
    color: 'var(--color-warning, #faad14)',
    border: `1px solid var(--color-warning-border, #ffe58f)`,
  },
  
  saveStatusError: {
    backgroundColor: 'var(--color-error-bg, #fff2f0)',
    color: 'var(--color-error, #ff4d4f)',
    border: `1px solid var(--color-error-border, #ffccc7)`,
  },
  
  modalBody: {
    flex: 1,
    padding: 0,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },
  
  editorContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    padding: `0 ${token.paddingLG}px`,
  },
  

  
  titleIcon: {
    fontSize: '20px',
    color: 'var(--color-primary, #1890ff)',
    flexShrink: 0,
  },
  

  
  editorWrapper: {
    flex: 1,
    overflow: 'hidden',
  },
  
  modalFooter: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: token.marginSM,
  },
  
  previewContainer: {
    flex: 1,
    padding: `${token.paddingLG}px`,
    backgroundColor: 'var(--color-bg-container, #ffffff)',
    overflow: 'auto',
  },
  
  titlePreviewCard: {
    marginBottom: `${token.marginLG}px`,
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
    border: `1px solid var(--color-border, ${colorToken.colorBorder})`,
    borderRadius: token.borderRadiusLG,
    backgroundColor: 'var(--color-bg-container, #ffffff)',
    
    '.ant-card-body': {
      padding: `${token.paddingMD}px`,
    },
  },
  
  titlePreviewSection: {
    display: 'flex',
    alignItems: 'center',
    gap: token.marginMD,
  },
  
  titlePreviewGroup: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: token.marginXS,
  },
  
  titlePreview: {
    fontSize: `${token.fontSizeHeading3}px`,
    fontWeight: token.fontWeightStrong,
    color: 'var(--color-text-base, #000000)',
    margin: 0,
    lineHeight: '1.4',
  },
  
  previewContent: {
    maxWidth: '800px',
    margin: '0 auto',
    backgroundColor: 'var(--color-bg-container, #ffffff)',
    padding: `${token.paddingLG}px`,
    borderRadius: token.borderRadiusLG,
    border: `1px solid var(--color-border, ${colorToken.colorBorder})`,
    minHeight: '100%',
  },
  
  markdownPreview: {
    fontSize: '14px',
    lineHeight: '1.6',
    color: 'var(--color-text-base, #000000)',
    
    // 标题样式
    '& h1, & h2, & h3, & h4, & h5, & h6': {
      margin: `${token.marginMD}px 0 ${token.marginSM}px 0`,
      fontWeight: token.fontWeightStrong,
      color: 'var(--color-text-base, #000000)',
      lineHeight: '1.4',
    },
    
    '& h1': {
      fontSize: '24px',
      borderBottom: `2px solid var(--color-border, ${colorToken.colorBorder})`,
      paddingBottom: `${token.paddingXS}px`,
    },
    
    '& h2': {
      fontSize: '20px',
      borderBottom: `1px solid var(--color-border, ${colorToken.colorBorder})`,
      paddingBottom: `${token.paddingXS}px`,
    },
    
    '& h3': {
      fontSize: '18px',
    },
    
    '& h4': {
      fontSize: '16px',
    },
    
    '& h5': {
      fontSize: '14px',
    },
    
    '& h6': {
      fontSize: '12px',
    },
    
    // 段落样式
    '& p': {
      margin: `${token.marginSM}px 0`,
      lineHeight: '1.6',
    },
    
    // 列表样式
    '& ul, & ol': {
      margin: `${token.marginSM}px 0`,
      paddingLeft: `${token.paddingLG}px`,
    },
    
    '& li': {
      margin: `${token.marginXS}px 0`,
      lineHeight: '1.6',
    },
    
    // 代码样式
    '& code': {
      backgroundColor: 'var(--color-bg-layout, #f5f5f5)',
      color: 'var(--color-text-base, #000000)',
      padding: '2px 4px',
      borderRadius: token.borderRadiusSM,
      fontSize: '13px',
      fontFamily: 'Monaco, Menlo, "Ubuntu Mono", monospace',
    },
    
    '& pre': {
      backgroundColor: 'var(--color-bg-layout, #f5f5f5)',
      border: `1px solid var(--color-border, ${colorToken.colorBorder})`,
      borderRadius: token.borderRadiusLG,
      padding: `${token.paddingMD}px`,
      margin: `${token.marginMD}px 0`,
      overflow: 'auto',
      
      '& code': {
        backgroundColor: 'transparent',
        padding: '0',
        border: 'none',
        fontSize: '13px',
        lineHeight: '1.5',
      },
    },
    
    // 链接样式
    '& a': {
      color: 'var(--color-primary, #1890ff)',
      textDecoration: 'none',
      
      '&:hover': {
        textDecoration: 'underline',
      },
    },
    
    // 表格样式
    '& table': {
      width: '100%',
      borderCollapse: 'collapse',
      margin: `${token.marginMD}px 0`,
      border: `1px solid var(--color-border, ${colorToken.colorBorder})`,
    },
    
    '& th, & td': {
      border: `1px solid var(--color-border, ${colorToken.colorBorder})`,
      padding: `${token.paddingSM}px ${token.paddingMD}px`,
      textAlign: 'left',
    },
    
    '& th': {
      backgroundColor: 'var(--color-bg-layout, #fafafa)',
      fontWeight: token.fontWeightStrong,
    },
    
    // 引用样式
    '& blockquote': {
      borderLeft: `4px solid var(--color-primary, #1890ff)`,
      margin: `${token.marginMD}px 0`,
      padding: `${token.paddingSM}px ${token.paddingMD}px`,
      backgroundColor: 'var(--color-bg-layout, #fafafa)',
      color: 'var(--color-text-secondary, #666666)',
      fontStyle: 'italic',
    },
    
    // 分割线样式
    '& hr': {
      border: 'none',
      borderTop: `1px solid var(--color-border, ${colorToken.colorBorder})`,
      margin: `${token.marginLG}px 0`,
    },
    
    // 强调样式
    '& strong': {
      fontWeight: token.fontWeightStrong,
    },
    
    '& em': {
      fontStyle: 'italic',
    },
    
    '& del': {
      textDecoration: 'line-through',
      color: 'var(--color-text-secondary, #666666)',
    },
  },
}));
